import { Hidden, TableRow, TableCell, IconButton,Box,Typography,Collapse,Button } from "@material-ui/core";
import KeyboardArrowDownRoundedIcon from "@material-ui/icons/KeyboardArrowDownRounded";
import KeyboardArrowUpRoundedIcon from "@material-ui/icons/KeyboardArrowUpRounded";
import { MultiSelect } from "./multislect";
import { useState } from "react";
function Row(props) {
  const { name, lastName, rut, email, onSubmit, zones, options, loading } =
    props;
  const [open, setOpen] = useState(false);
  const [selectedZones, setSelectedZones] = useState(zones);
  const handleSubmit = async (e) => {
    e.preventDefault();
    await onSubmit(selectedZones);
    setOpen(false);
  };
  const changeValue = (newValue) => {
    setSelectedZones(newValue);
  };

  return (
    <>
      <Hidden xsDown>
        <TableRow style={{ ...(loading && { opacity: "0.7" }) }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? (
                <KeyboardArrowUpRoundedIcon />
              ) : (
                <KeyboardArrowDownRoundedIcon />
              )}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">
            {name}
          </TableCell>
          <TableCell align="right">{lastName}</TableCell>
          <TableCell align="right">{rut}</TableCell>
          <TableCell align="right">{email}</TableCell>
        </TableRow>
      </Hidden>

      <Hidden smUp>
        <TableRow style={{ margin: 0, ...(loading && { opacity: "0.7" }) }}>
          <TableCell style={{ padding: 12 }}>
            <Box display={"flex"} style={{ gap: 8 }}>
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
              >
                {open ? (
                  <KeyboardArrowUpRoundedIcon />
                ) : (
                  <KeyboardArrowDownRoundedIcon />
                )}
              </IconButton>
              <Box>
                <Typography
                  style={{ fontWeight: "bold", overflowWrap: "anywhere" }}
                >
                  {`${name} ${lastName}`}
                </Typography>
                <Typography
                  style={{ fontSize: "0.9rem", overflowWrap: "anywhere" }}
                >
                  {" "}
                  {rut}
                </Typography>
                <Typography
                  style={{ fontSize: "0.9rem", overflowWrap: "anywhere" }}
                >
                  {" "}
                  {email}
                </Typography>
              </Box>
            </Box>
          </TableCell>
        </TableRow>
      </Hidden>

      <TableRow
        style={{
          margin: 0,
          border: "none",
          position: "relative",
          ...(loading && { opacity: "0.7" }),
        }}
      >
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography
                color="textPrimary"
                style={{ margin: "20px 0", textAlign: "start" }}
              >
                Administrar zonas de visita
              </Typography>
              <form
                onSubmit={handleSubmit}
                style={{ width: "100%", marginBottom: 20 }}
              >
                <MultiSelect
                  value={selectedZones}
                  options={options}
                  changeValue={changeValue}
                />
                <Box justifyContent={"end"} display={"flex"}>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ textTransform: "none", marginTop: 16 }}
                    type="submit"
                  >
                    Guardar
                  </Button>
                </Box>
              </form>{" "}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

export default Row;
